import { Box } from '@/ui/primitives';
import { deltaIndicatorSx } from './deltaIndicatorStyles';
import type { ReactElement, ReactNode } from 'react';

export const DeltaIndicator = ({ isPositive }: { isPositive: boolean }): ReactElement => (
  <Box component="span" sx={deltaIndicatorSx}>
    {isPositive ? '▲' : '▼'}
  </Box>
);

export const DeltaWithIndicator = ({
  label,
  isPositive,
}: {
  label: ReactNode;
  isPositive: boolean;
}): ReactElement => (
  <>
    {label}
    <DeltaIndicator isPositive={isPositive} />
  </>
);
